import React from 'react';
import { Box, ToggleButton, ToggleButtonGroup } from '@mui/material';

export type DatePeriod = 'today' | '7d' | '30d' | '90d';

interface DateRangePickerProps {
  period: DatePeriod;
  onChange: (period: DatePeriod) => void;
}

const DateRangePicker: React.FC<DateRangePickerProps> = ({ period, onChange }) => {
  const handleChange = (_event: React.MouseEvent<HTMLElement>, newPeriod: DatePeriod | null) => {
    if (newPeriod !== null) {
      onChange(newPeriod);
    }
  };

  return (
    <Box sx={{ mb: 2 }}>
      <ToggleButtonGroup
        value={period}
        exclusive
        onChange={handleChange}
        size="small"
      >
        <ToggleButton value="today">Today</ToggleButton>
        <ToggleButton value="7d">7 Days</ToggleButton>
        <ToggleButton value="30d">30 Days</ToggleButton>
        <ToggleButton value="90d">90 Days</ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};

export default DateRangePicker;
